$(window).ready(function() {
    //TODO: enkel voor profile page...
    calculateAvatarPosition();
    $( window ).resize(function() {
        calculateAvatarPosition();
    });

    function calculateAvatarPosition(){
        if($('#top-filler-background').length){
            //img_row_top = $('#top-filler-background').offset().top + ($('#top-filler-background').height() / 2) - ($('#tx_image img').height() / 2) - 10;
            $('#tx_image_row').css({'left': ($('#userprofile').width() / 2) - ($('#tx_image').width() / 2), 'position':'absolute'});
        }
    }

});